module.exports = __webpack_public_path__ + "media/frontend/assets/logo-large-450b16eef23f67034a1565d0951baa2d.png";